import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

// Optional authenticator-app sign-in for portal users (existing /api/mfa endpoints).
export const ClientMfaCard = () => {
  const [st, setSt] = useState(null);
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState('');
  const load = () => api.get('/api/mfa/status').then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const start = async () => { try { setSetup((await api.post('/api/mfa/setup')).data); } catch (e) { toast.error(e.response?.data?.detail || 'Could not start setup'); } };
  const finish = async (path, msg) => {
    try { await api.post(path, { code }); toast.success(msg); setSetup(null); setCode(''); load(); } catch (e) { toast.error(e.response?.data?.detail || 'That code did not work'); }
  };

  return (
    <Card data-testid="client-mfa-card">
      <CardHeader><CardTitle className="flex items-center gap-2 text-base"><KeyRound className="h-4 w-4" />Two-step sign-in (optional)</CardTitle></CardHeader>
      <CardContent className="space-y-4 text-sm">
        <div>Status: <Badge variant="outline" data-testid="client-mfa-status">{st?.enabled ? 'On' : 'Off'}</Badge></div>
        {!st?.enabled && !setup && <Button onClick={start} data-testid="client-mfa-setup">Set up authenticator app</Button>}
        {setup && (
          <div className="space-y-3">
            <img src={setup.qr} alt="Scan with your authenticator app" className="h-40 w-40" data-testid="client-mfa-qr" />
            <p className="text-xs text-muted-foreground font-mono break-all">Key: {setup.secret}</p>
          </div>
        )}
        {(setup || st?.enabled) && (
          <div className="flex gap-2 max-w-xs">
            <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="6-digit code" data-testid="client-mfa-code" />
            {setup ? <Button onClick={() => finish('/api/mfa/verify', 'Two-step sign-in is on')} data-testid="client-mfa-verify">Turn on</Button>
              : <Button variant="outline" onClick={() => finish('/api/mfa/disable', 'Two-step sign-in is off')} data-testid="client-mfa-disable">Turn off</Button>}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
